import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { apiURL } from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import { clickUploadToDownloadList } from 'gatsby-theme-kn/src/utils/media_database_download_list'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const MediaDatabaseDownloadListItem = ({ item, setter }) => {
  const { t } = useTranslation()
  const { data, loading, error } = useAxiosPartnerPortal(
    apiURL('media_engine/uploads/' + item + '?v=1'),
    {},
    'get'
  )

  return (
    <>
      {loading && <LoadingSpinner />}
      {data && (
        <>
          <div style={{ display: 'block', maxWidth: '85px' }}>
            <img
              className="img-fluid"
              src={data.urls.thumbnail}
              title={data.title}
            />
          </div>
          <div className="media-cart-list-item-title" title={data.title}>
            {data.title}
          </div>
          <span className="media-cart-list-item-controls">
            <a
              className="control-remove"
              href="/"
              onClick={(e) => {
                e.preventDefault()
                clickUploadToDownloadList(item, setter)
              }}
            >
              <i className="far fa-times"></i>
            </a>
          </span>
        </>
      )}
    </>
  )
}

export default MediaDatabaseDownloadListItem
